export function trapEvent(event) {
    if (!event) {
        return;
    }
    event.preventDefault();
    event.stopPropagation();
}
export const isSpecialKey = (e) => e.altKey || e.metaKey || e.shiftKey || e.ctrlKey;
const INTERACTIVE_SELECTOR = [
    "input:not([type=hidden])",
    "button",
    "textarea",
    "a",
    "select",
    "option",
    "label", // should be associated with an interactive element
].join(",");
export const isTriggeredByInteractiveElement = (ev) => {
    if (!(ev.target instanceof HTMLElement)) {
        return false;
    }
    // check ancestors because the target might be a child of an interactive element
    const interactiveElOrAncestor = ev.target.closest(INTERACTIVE_SELECTOR);
    return interactiveElOrAncestor ? ev.currentTarget.contains(interactiveElOrAncestor) : false;
};
//# sourceMappingURL=EventHelpers.js.map